import React, { useEffect, useState } from 'react';
import BankSearchModal from './BankSearchModal';
import { resolveBankByIdentifier } from '../api/banks';
import { labelWithSeq } from './ScopeField';

/**
 * Champ "Banque" pour un filtre de portee (Number Control, Parametres Loterie,
 * Marriage Gratis, Exposition, Paris gagnants...) : la valeur que l'utilisateur
 * tape est en general le username du bank (8 chiffres, celui affiche/tape sur
 * le POS) — pas un numero. Mais certains tableaux de l'app (ex. colonne "ID"
 * de Act/Desactiver Ventes Manuel) affichent Bank.seq (numero propre a la
 * company), et un utilisateur qui retape CE nombre-la doit aussi trouver sa
 * banque plutot que de tomber sur "introuvable" — d'ou
 * `resolveBankByIdentifier` (username en priorite, repli sur seq si la saisie
 * est numerique et le username n'a rien trouve).
 *   - frappe directe : `onBlur` resout la saisie en {id, name} — "Banque
 *     introuvable" sinon, meme pattern que LotteryCodeField pour les codes
 *     loterie.
 *   - loupe -> `BankSearchModal` (recherche large, username OU nom) ; la
 *     selection remplit aussi la case avec le username reel du bank choisi.
 * La page garde la source de verite : elle passe `id`/`name` (l'id interne,
 * utilise pour l'appel API de scope) et recoit `onResolve(id, name)`.
 */
export default function BankScopeField({
  id,
  name = '',
  onResolve,
  inputClass = '',
  iconClass = '',
  nameClass = '',
  errClass = '',
}) {
  const [usernameInput, setUsernameInput] = useState('');
  const [err, setErr] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  // L'id a ete efface ailleurs (ex: changement de filtre) -> vide aussi la case.
  useEffect(() => { if (!id) setUsernameInput(''); }, [id]);

  const resolve = async () => {
    const u = usernameInput.trim();
    if (u === '') { setErr(''); onResolve('', ''); return; }
    const bank = await resolveBankByIdentifier(u);
    if (bank) { setErr(''); onResolve(String(bank.id), labelWithSeq(bank.seq, bank.name)); } else { setErr('Banque introuvable'); }
  };

  return (
    <>
      <input
        className={inputClass}
        type="text"
        inputMode="numeric"
        value={usernameInput}
        onChange={(e) => { setUsernameInput(e.target.value); setErr(''); }}
        onFocus={(e) => e.target.select()}
        onBlur={resolve}
      />
      <span className={iconClass} onClick={() => setModalOpen(true)}>🔍</span>
      {err
        ? <span className={errClass || nameClass} style={{ color: '#c0392b' }}>{err}</span>
        : (name ? <span className={nameClass}>{name}</span> : null)}
      {modalOpen && (
        <BankSearchModal
          onSelect={(bid, bname, busername, bseq) => {
            setUsernameInput(busername || '');
            setErr('');
            onResolve(String(bid), labelWithSeq(bseq, bname));
          }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
